import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import Autocomplete from 'react-google-autocomplete';

import Map from '../Base/Map';
import * as ObjectConst from '../../constants/Property';
import * as GooglePlacesConst from '../../constants/GooglePlaces';
import {updateField, setAddressValid} from '../../actions/CreatingObjectPage';

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updateField: (objectId, updateFieldCommand) => {
    },
    setAddressValid: isAddressValid => {
    }
};

class Address extends Component {
    constructor(props) {
        super(props);

        this.state = {
            CITY: '',
            INDEX: '',
            STREET: '',
            COUNTRY: '',
            PROVINCE: '',
            APARTMENT: '',
            AUTOCOMPLETE: '',
            STREET_NUMBER: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.createdObject.id !== undefined) {
            const userAddress = nextProps.createdObject.userAddress;

            this.setState({
                LAT: nextProps.createdObject.location.latitude,
                LNG: nextProps.createdObject.location.longitude,
                CITY: userAddress.city === undefined || userAddress.city === null ? '' : userAddress.city,
                INDEX: userAddress.index === undefined || userAddress.index === null ? '' : userAddress.index,
                STREET: userAddress.street === undefined || userAddress.street === null ? '' : userAddress.street,
                COUNTRY: userAddress.country === undefined || userAddress.country === null ? '' : userAddress.country,
                PROVINCE: userAddress.province === undefined || userAddress.province === null ? '' : userAddress.province,
                APARTMENT: userAddress.apartment === undefined || userAddress.apartment === null ? '' : userAddress.apartment,
                STREET_NUMBER: userAddress.streetNum === undefined || userAddress.streetNum === null ? '' : userAddress.streetNum,
                AUTOCOMPLETE: userAddress.autocomplete === undefined || userAddress.autocomplete === null ? '' : userAddress.autocomplete
            });
        }
    }

    handleAddressChange(place) {
        const newState = {};

        newState[ObjectConst.FIELDS.LAT] = place.geometry.location.lat();
        newState[ObjectConst.FIELDS.LNG] = place.geometry.location.lng();
        newState[ObjectConst.FIELDS.AUTOCOMPLETE] = place.formatted_address;

        place.address_components.forEach(elem => {
            elem.types.forEach(type => {
                switch (type) {
                    case GooglePlacesConst.TYPES.STREET_NUMBER:
                        newState[ObjectConst.FIELDS.STREET_NUMBER] = elem.long_name;
                        break;
                    case GooglePlacesConst.TYPES.ROUTE:
                        newState[ObjectConst.FIELDS.STREET] = elem.long_name;
                        break;
                    case GooglePlacesConst.TYPES.LOCALITY:
                        newState[ObjectConst.FIELDS.CITY] = elem.long_name;
                        break;
                    case GooglePlacesConst.TYPES.ADMINISTRATIVE_AREA_LEVEL_1:
                        newState[ObjectConst.FIELDS.PROVINCE] = elem.long_name;
                        break;
                    case GooglePlacesConst.TYPES.COUNTRY:
                        newState[ObjectConst.FIELDS.COUNTRY] = elem.long_name;
                        break;
                    case GooglePlacesConst.TYPES.POSTAL_CODE:
                        newState[ObjectConst.FIELDS.INDEX] = elem.long_name;
                        break;
                    default:
                        break;
                }
            });
        });

        Object.entries(newState).forEach(elem => {
            this.updateField(elem[0], elem[1]);
        });

        this.setState(newState);
    }

    updateField(name, value) {
        const updateFieldCommand = {
            name: name,
            value: value
        };
        this.props.updateField(this.props.createdObject.id, updateFieldCommand);
        this.validation();
    }

    handleChange(event) {
        const newState = {};
        newState[event.target.name] = event.target.value;

        this.setState(newState);
    }

    handleBlur(event) {
        this.updateField(event.target.name, event.target.value);
    }

    handleFixMarkerClick() {
        const {
            createdObject: {
                location: {
                    fixMarker
                }
            }
        } = this.props;

        this.updateField(ObjectConst.FIELDS.FIX_MARKER, !fixMarker);
    }

    onMapClick(event) {
        const newState = {};

        newState[ObjectConst.FIELDS.LAT] = event.latLng.lat();
        newState[ObjectConst.FIELDS.LNG] = event.latLng.lng();

        Object.entries(newState).forEach(elem => {
            this.updateField(elem[0], elem[1]);
        });
        this.setState(newState);
    }

    validation() {
        let isAddressValid = true;

        if (this.state.CITY.length === 0) isAddressValid = false;
        if (this.state.INDEX.length === 0) isAddressValid = false;
        if (this.state.STREET.length === 0) isAddressValid = false;
        if (this.state.COUNTRY.length === 0) isAddressValid = false;
        if (this.state.PROVINCE.length === 0) isAddressValid = false;
        if (this.state.STREET_NUMBER.length === 0) isAddressValid = false;

        if (this.props.isAddressValid !== isAddressValid) {
            this.props.setAddressValid(isAddressValid);
        }
    }

    render() {
        const {
            i18n,
            isActive,
            defaultLat,
            createdObject,
            isGoogleApiInit,
            createdObject: {
                location: {
                    fixMarker
                }
            }
        } = this.props;

        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.address']}
                    </h3>
                </div>

                <div className="clearfix mt30">
                    <label className="">
                        <span className="info">
                            <i className="fa fa-question-circle" />
                            <span>
                                {i18n['creatingObjectPage.address.hint1']}
                            </span>
                        </span>
                        {i18n['creatingObjectPage.addressOfTheObject']}:
                        {this.props.isGoogleApiInit && <Autocomplete
                            placeholder="-"
                            types={['address']}
                            onChange={::this.handleChange}
                            value={this.state.AUTOCOMPLETE}
                            name={ObjectConst.FIELDS.AUTOCOMPLETE}
                            onPlaceSelected={place => {
                                ::this.handleAddressChange(place);
                            }}
                        />}
                    </label>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.address.hint2']}
                                    </span>
                                </span>
                                {i18n['creatingObjectPage.city']}:
                                <input
                                    type="text"
                                    placeholder="-"
                                    value={this.state.CITY}
                                    onBlur={::this.handleBlur}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.CITY}
                                    className={this.state.CITY.length === 0 ? 'invalid' : ''}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.address.hint3']}
                                    </span>
                                </span>
                                {i18n['creatingObjectPage.provinces']}:
                                <input
                                    type="text"
                                    placeholder="-"
                                    value={this.state.PROVINCE}
                                    onBlur={::this.handleBlur}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.PROVINCE}
                                    className={this.state.PROVINCE.length === 0 ? 'invalid' : ''}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.address.hint4']}
                                    </span>
                                </span>
                                {i18n['creatingObjectPage.country']}:
                                <input
                                    type="text"
                                    placeholder="-"
                                    value={this.state.COUNTRY}
                                    onBlur={::this.handleBlur}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.COUNTRY}
                                    className={this.state.COUNTRY.length === 0 ? 'invalid' : ''}
                                />
                            </label>
                        </div>
                    </div>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.address.hint5']}
                                    </span>
                                </span>
                                {i18n['creatingObjectPage.index']}:
                                <input
                                    type="text"
                                    placeholder="-"
                                    value={this.state.INDEX}
                                    onBlur={::this.handleBlur}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.INDEX}
                                    className={this.state.INDEX.length === 0 ? 'invalid' : ''}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.address.hint6']}
                                    </span>
                                </span>
                                {i18n['creatingObjectPage.street']}:
                                <input
                                    type="text"
                                    placeholder="-"
                                    value={this.state.STREET}
                                    onBlur={::this.handleBlur}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.STREET}
                                    className={this.state.STREET.length === 0 ? 'invalid' : ''}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.address.hint7']}
                                    </span>
                                </span>
                                {i18n['creatingObjectPage.houseNumber']}:
                                <input
                                    type="text"
                                    placeholder="-"
                                    onBlur={::this.handleBlur}
                                    onChange={::this.handleChange}
                                    value={this.state.STREET_NUMBER}
                                    name={ObjectConst.FIELDS.STREET_NUMBER}
                                    className={this.state.STREET_NUMBER.length === 0 ? 'invalid' : ''}
                                />
                            </label>
                        </div>
                    </div>

                    <label className="">
                        <span className="info">
                            <i className="fa fa-question-circle" />
                            <span>
                                {i18n['creatingObjectPage.address.hint8']}
                            </span>
                        </span>
                        {i18n['creatingObjectPage.apartmentNumber']}:
                        <textarea
                            placeholder="-"
                            onBlur={::this.handleBlur}
                            value={this.state.APARTMENT}
                            onChange={::this.handleChange}
                            name={ObjectConst.FIELDS.APARTMENT}
                        />
                    </label>

                    <div className="clearfix mt30">
                        <div className="clearfix add_mark" onClick={::this.handleFixMarkerClick}>
                            {fixMarker &&
                            <i className="fa fa-check" />} {i18n['creatingObjectPage.fixTheMark']}
                        </div>
                    </div>

                    <div className="clearfix mt30 map_wrapper">
                        {isGoogleApiInit && this.state.LAT !== undefined && defaultLat !== undefined && isActive &&
                        <Map
                            id="mapInAddressTab"
                            objects={[createdObject]}
                            centerLat={this.state.LAT}
                            centerLng={this.state.LNG}
                            onMapClick={::this.onMapClick}
                            isDoNotHandleClickMarker={true}
                        />}
                    </div>

                    <div className="clearfix note">
                        <p>
                            * {i18n['creatingObjectPage.address.hint9']}
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

Address.propTypes = propTypes;
Address.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    defaultLat: state.configuration.main.defaultLat,
    isGoogleApiInit: state.configuration.isGoogleApiInit,
    createdObject: state.creatingObjectPage.createdObject,
    isAddressValid: state.creatingObjectPage.validation.isAddressValid
});

const mapDispatchToProps = {
    updateField,
    setAddressValid
};

export default connect(mapStateToProps, mapDispatchToProps)(Address);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/Address.js